import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const AccordionWrapper = styled(Box)`
  border: 1px solid ${theme.token.var('colors.green.a50')};
  border-radius: ${theme.token.var('borderRadius.small')};
`

export const AccordionHeader = styled.header`
  display: flex;
  justify-content: space-between;
`

export const AccordionContentWrapper = styled('div', {
  shouldForwardProp: (prop) => !['isExpanded', 'collapsedHeight', 'expandedHeight'].includes(prop.toString()),
})<{
  isExpanded: boolean
  collapsedHeight: number
  expandedHeight: number
}>`
  position: relative;
  max-height: ${({ isExpanded, collapsedHeight, expandedHeight }) => (isExpanded ? expandedHeight : collapsedHeight)}px;
  margin-bottom: 20px;
  overflow: hidden;

  transition: max-height 0.25s ease-in;

  &::after {
    content: '';
    background: linear-gradient(0deg, rgba(255, 255, 255) 0%, rgba(255, 255, 255, 0) 100%);

    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    opacity: ${({ isExpanded }) => (isExpanded ? 0 : 1)};
    pointer-events: none;

    transition: opacity 0.25s ease-in;
  }
`

export const AccordionContent = styled.div``
